import '../scss/app.scss';
import './components/slider.js';

let $ = window.jQuery;

$(function() {
  $('a').each(function() {
    if( !(location.hostname === this.hostname || !this.hostname.length )) {
      $(this).attr('target', '_blank');
      $(this).attr('rel', 'noopener noreferrer');
    }
  });

  $(document).on('click', '.mobile-nav-toggle', function() {
    $(this).toggleClass('is-active');

    $('.main-navigation').slideToggle();
  });

  $(document).on('click', '#menu-site-navigation > li > a', function(e) {
    if (e.offsetX >  $(this)[0].offsetWidth) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $(this).siblings('.sub-menu').slideToggle();
    }
  });
});
